import Request from "../utils/request";

export const get = (data) => Request.get("/api/role", data);
export const update = (data) => Request.put("/api/role", data);